'use strict';

customerZone.controller('ResetPasswordController', ['$location', '$window', '$timeout', 'Session', 'CustomerService',
    'utils', 'errorCode', 'ControllerBase', function($location, $window, $timeout, Session, CustomerService, utils,
                                                     errorCode, ControllerBase){

        var self = this;
        ControllerBase.call(this, utils);

        var STATE = {
            REQUEST: 'request',
            PERFORM: 'perform',
            DONE: 'done',
            MAIL_PENDING: 'mail pending'
        };

        var state = STATE.REQUEST;

        self.loading = false;
        self.credentials = '';
        self.resetCode = '';
        self.newPassword = '';
        self.sentBySms = false;
        self.formPrefilled = false;
        var destination = null;

        // handling errors only known after a request has been made
        self.uwaValidationErrors = {};

        self.showRequestForm = function(){
            return state === STATE.REQUEST;
        };

        self.showPerformForm = function(){
            return state === STATE.PERFORM;
        };

        self.showMailPending = function(){
            return state === STATE.MAIL_PENDING;
        };

        self.requestResetCode = function(){
            var requestPromise = self.recaptcha.execute()
                .then(function(recaptchaResponse){
                    return CustomerService.requestVerificationCode(self.credentials, recaptchaResponse, destination);
                })
                .then(function(){
                    if (isEmail(self.credentials)) {
                        state = STATE.MAIL_PENDING;
                    }
                    else {
                        self.sentBySms = true;
                        state = STATE.PERFORM;
                    }
                })
                .catch(function(error){
                    if (errorCode.is(error, errorCode.UNKNOWN_USER)){
                        busy.showError('unknown_user_try_again');
                    }
                    if (errorCode.is(error, errorCode.RESET_BY_EMAIL_IMPOSSIBLE)){
                        busy.showError('cannot_reset_by_email_use_phonenr_instead');
                    }
                    throw error;
                });
            var busy = utils.showBusy(requestPromise, 'request_pending', 'new_password_requested');
            return busy.wrappedPromise;
        };

        self.performPasswordReset = function(){
            if (state === STATE.DONE) {
                utils.goToLogin();
                return;
            }
            var resetPromise = CustomerService.resetPassword(self.credentials, self.resetCode, self.newPassword)
                .then(function(targetUrl){
                    state = STATE.DONE;
                    if (!targetUrl)
                        utils.goToLogin();
                    else
                        utils.redirect(targetUrl);
                })
                .catch(function(error){
                    state = STATE.REQUEST;
                    if (self.handleValidationErrors(error, [
                        {code: errorCode.PASSWORD_TOO_COMMON, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_common'},
                        {code: errorCode.PASSWORD_ENTIRELY_NUMERIC, field: 'newPassword', on: 'newPassword',
                            message: 'password_entirely_numeric_error_message'},
                        {code: errorCode.PASSWORD_TOO_SIMILAR, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_similar_error_message'},
                        {code: errorCode.PASSWORD_SIMILAR_TO_DETAILS, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_similar_to_details_error_message'}
                    ], busy))
                        state = STATE.PERFORM;

                    if (errorCode.is(error, errorCode.INVALID_RESET_CODE)){
                        busy.showError('password_update_code_expired');
                    }
                    if (errorCode.is(error, errorCode.INVALID_PHONE_VERIFICATION_CODE)){
                        busy.showError('password_update_code_expired');
                    }
                    throw error;
                });
            var busy = utils.showBusy(resetPromise, 'password_change_ongoing',
                'password_change_done__you_can_log_in_now');
            return busy.wrappedPromise;
        };

        var init = function(){
            destination = $location.search().destination;
            self.credentials = utils.escapeHtmlAndCurlies($location.search().credentials);
            self.resetCode = utils.escapeHtmlAndCurlies($location.search().code);

            if (self.credentials && !self.resetCode) {
                $timeout(function(){ self.requestResetCode(); });
            }
            else if (self.credentials && self.resetCode) {
                self.sentBySms = false;
                self.formPrefilled = true;
                state = STATE.PERFORM;
            }
        };

        var isEmail = function(credentials){
            // rather naive, but for msisdn/email it'll do
            return credentials.indexOf('@') >=0;
        };

        init();

    }]);
